<template>
  <div class="page-wrapper" style="padding-top: 0">
    <div class="">
      <Button @click="addBuild" type="primary" v-p="{api:'housebuilding/edit'}">添加楼栋信息</Button>
    </div>
    <build-item v-for="(item,index) in dataListCopy"
                :formData="item"
                :itemIndex="index"
                @deletebuild="deletebuild"
                :ref="'builditem'+index"
                :propertyEnum="propertyEnum"
                :buildingStructureEnum="buildingStructureEnum"
                :directionEnum="directionEnum"
                :key="'keyA'+index"
    ></build-item>
    <div>
      <save-and-cancel @save="save" @cancel="cancel"  v-p="{api:'housebuilding/edit'}">
      </save-and-cancel>
    </div>

  </div>
</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import BuildItem from '../../components/BuildItem'
  import {toEdit, buildingUpdate, validDeleteContidion} from "../../../../../api/project";
  import {deepClone} from "../../../../../utils/format";

  export default {
    name: 'BuildUpdate',
    components: {
      SaveAndCancel,
      BuildItem
    },
    props: {
      projectFid: {
        type: String,
        default: null
      },
    },
    watch: {
      projectFid() {
        this.getBuildInfo()
      },
      dataList(value) {
        this.dataListCopy = deepClone(value)
      }
    },
    data() {
      return {
        propertyEnum: [],
        buildingStructureEnum: [],
        directionEnum: [],
        dataList: [],
        dataListCopy: []
      }
    },
    methods: {
      deletebuild(index) {
        this.$Modal.confirm({
          // title:'',
          content: '<p>确认删除本条楼栋记录？</p>',
          onOk: () => {
            var item = this.dataListCopy[index]
            if (!item.fid) {
              this.dataListCopy.splice(index, 1)
            }
            else {   //存在fid需要校验
              let params = {
                buildingFid: item.fid
              }
              validDeleteContidion(params).then(res => {
                this.dataListCopy.splice(index, 1)
              }).catch(error=>{})
            }
          }
        })
      },
      buildingUpdate() {
        var params = {
          projectFid: this.projectFid,
          thouseBuildingDtos: this.dataListCopy
        }
        buildingUpdate(params).then(res => {
          if (res.code == 0) {
            this.$Message.success('楼栋信息修改成功')
          }
          else {
            this.$Message.info(res.message)
          }
        }).catch(error => {

        })
      },
      validForm() {
        var flag = true
        for (var i  in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].$refs['buildItem'].validate(bool => {
            if (bool == false) {
              flag = false
            }
          })
        }
        return flag
      },
      save() {
        if (!this.validForm()) {
          this.$Message.info('请检查填写内容！')
          return
        }
        this.dataListCopy.forEach(ele => {
          ele.buildingRentablefloor = ele.floorList.join(',')
        })
        this.buildingUpdate()
        // saveBaseInfo(this.dataListCopy).then(res=>{
        // })

      },
      cancel() {
        this.dataListCopy = deepClone(this.dataList)
        for (var i  in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].$refs['buildItem'].resetFields()
        }
      },
      addBuild() {
        this.dataListCopy.push(
          {
            "buildingArea": '',
            "buildingBusinessType": '',
            "buildingDirection": '',
            "buildingElevatornumber": '',
            "buildingFinishYear": '',
            "buildingFloorheight": '',
            "buildingFloornumber": '',
            "buildingName": "",
            "buildingOutsidearea": '',
            "buildingRentablefloor": "",
            "buildingStairnumber": '',
            "buildingStructure": '',
            fid: "",
            "projectFid": this.projectFid,
            "projectPropertyType": '',
            floorList: []
          }
        )
      },
      getBuildInfo() {
        if (!this.projectFid) {
          return
        }
        var params = {
          projectFid: this.projectFid
        }
        toEdit(params).then(res => {
          this.buildingStructureEnum = res.data.buildingStructureEnum
          this.directionEnum = res.data.directionEnum
          this.propertyEnum = res.data.propertyEnum
          var list = res.data.tHouseBuildingDtos

          list.forEach(ele => {
            if(!ele.buildingRentablefloor){
              ele['floorList']=[]
            }
            else {
              ele['floorList'] = ele.buildingRentablefloor.split(',')
            }
          })
          res.data.tHouseBuildingDtos && (this.dataList = res.data.tHouseBuildingDtos)
        }).catch(error => {})
      }
    },
    created() {
      this.getBuildInfo()

    },
  }
</script>

<style scoped>

</style>
